<template>
<div class='mt-4 mb-4' >
    <h4>
        <b-icon icon="info-square" scale="1.0"></b-icon>
        <span>{{ $t('terminals.announcements.active_announcements') }}</span>
        <a v-if="!editorAction" href="#" class="action-link" @click="onNewItem" v-b-tooltip :title="$t('button.add')"><b-icon icon="plus-circle-fill" scale="1.0"></b-icon></a>
        <a v-else  href="#" class="action-link" @click="onReset" v-b-tooltip :title="$t('button.close')"><b-icon icon="x" scale="1.8"></b-icon></a>
    </h4>
    <div v-if="!editorAction">
        <!-- <TableActionHeader @newItem="onNewItem" :searchInput="false" />-->
        <div v-if="!announcementItems || announcementItems.length == 0" class='info note'>
            {{ $t('terminals.announcements.no_announcements') }}
        </div>
        <b-table
            v-else
            style="white-space: pre-line;"
            small
            striped
            hover
            selectable
            select-mode="single"
            @row-selected="onRowSelected"
            :fields="announcementFields"
            :items="announcementItems"
            thead-tr-class="term-disp-announcements-headtr"
            tbody-tr-class="term-disp-announcements-bodytr">
        </b-table>

    </div>
    <div v-else  style='border: 1px solid red; padding: 5px;'>
        <TermDispAnnouncementEditor
            :selectedAnnouncement="selectedAnnouncement"
            :terminalId="terminalId"
            :displayId="displayId"
            :action="editorAction"
            @reset="onReset" />
    </div>
</div>
</template>

<script>
import TermDispAnnouncementEditor from '@/components/Terminals/TermDispAnnouncementEditor.vue';
import terminalView from '@/store/terminals/terminalView';
import moment from 'moment';

export default {
    name: 'TerminalDisplayAnnouncements',
    components: { TermDispAnnouncementEditor },
    props: ['terminalId'],
    data: function() {
        return {
            perPage: 7,
            currentPage: 1,
            selectedAnnouncement: null,
            editorAction: null
        };
    },
    computed: {
        announcementFields() {
            return [
                { key: 'otsikko' , label: this.$t('terminals.announcements.name'), sortable: false },
                { key: 'content' , label: this.$t('terminals.announcements.content'), sortable: false, formatter: (value, key, item) => {
                        var text = '';
                        for (var i in item.tiedoteTextList) {
                            text += item.tiedoteTextList[i] + '\n';
                        }
                        return text;
                    }
                },
                { key: 'active', label: this.$t('terminals.announcements.active'), sortable: false, formatter: (value, key, item) => {
                        var time = this.formatTimestamp(item.kelpoisuusalkaa);
                        time += ' -\n';
                        var time2 = this.formatTimestamp(item.kelpoisuusloppuu);
                        return time + time2;
                    }
                }
            ];
        },
        announcementItems() {
            if (this.$store.state.terminalView.selectedDisplay &&
                this.$store.state.terminalView.selectedDisplay.announcements) {
                return this.$store.state.terminalView.selectedDisplay.announcements;
            }
            return [];
        },
        displayId() {
            if (this.$store.state.terminalView.selectedDisplay &&
                this.$store.state.terminalView.selectedDisplay.displayId) {
                return this.$store.state.terminalView.selectedDisplay.displayId;
            }
            return null;
        }
    },
    methods: {
        onNewItem() {
            this.selectedAnnouncement = {
                    tunnus: -1,
                    otsikko: '',
                    tiedoteTextList: {}
                };
            this.editorAction = 'add';
        },
        onRowSelected(items) {
            if (items[0]) {
                this.selectedAnnouncement = { ...items[0] }; // Copy.
                this.editorAction = 'remove';
            }
        },
        onReset() {
            this.editorAction = null;
            this.selectedAnnouncement = null;
        },
        formatTimestamp(timestamp) {
            return new moment(timestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
        }
    },
    created() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
    }
}
</script>

<style lang="scss">
.term-disp-announcements-headtr th {
    font-size: 11px !important;
    padding: 5px !important;
}

.term-disp-announcements-bodytr td {
    font-family: Verdana,Arial,Helvetica,sans-serif;
    font-size: 11px;
    color: #515151;
    padding: 2px 2px 2px 5px !important;
}
</style>
